import axios from "axios";

// 🌍 AUTO-SWITCH BASE URL (LOCAL → PROD)
const defaultApiBaseUrl =
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? "http://127.0.0.1:8080/production"
    : "https://api.herspringboard.in/production";

export const BaseUrl: string =
  process.env.REACT_APP_API_BASE_URL || defaultApiBaseUrl;

// ssCommon Headers
export const ApplicationJsonConfigHeader = {
  "Content-Type": "application/json",
};

export const FormDataFileConfigHeader = {
  "Content-Type": "multipart/form-data",
};

//  Attach Token Automatically
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers["authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// 🚨 Global Error Capture
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);
